export const parseRouterQuery = (query: string | string[] | undefined) => {
  if (!query) {
    return ''
  }

  return typeof query === 'string' ? query : query.join('')
}

export function parseRouterQueryAsNumber(input: unknown): number | null {
  if (!input) {
    return null
  }
  const numberVal = Number(input)
  if (Number.isNaN(numberVal)) {
    return null
  }
  return numberVal
}

export function parseRouterQueryAsNumberUndefined(input: unknown): number | undefined {
  if (!input) {
    return undefined
  }
  const numberVal = Number(input)
  if (Number.isNaN(numberVal)) {
    return undefined
  }
  return numberVal
}

export function tryParseAsNumberArray(inputs: string | string[] | undefined): Array<number> | undefined {
  if (!inputs) {
    return undefined
  }

  const numberString = inputs?.toString()?.split(',')

  const result = numberString?.map((input) => {
    const number = parseRouterQueryAsNumberUndefined(input)
    return number !== undefined ? number : 0
  })

  return result
}

export function tryParseAsStringArray(inputs: string | string[] | undefined): Array<string> | undefined {
  if (!inputs) {
    return undefined
  }

  const stringArray = inputs?.toString()?.split(',')

  const result = stringArray?.map((input) => {
    const string = parseRouterQuery(input)
    return string !== undefined ? string : ''
  })

  return result
}

export function tryParseAsDate(input: unknown): Date | undefined {
  if (!input) {
    return undefined
  }
  const parseResult = Date.parse(input as string)
  if (Number.isNaN(parseResult)) {
    return undefined
  }
  return new Date(parseResult)
}

export function parseRouterQueryAsBoolean(input: unknown): boolean | null {
  if (input === true) return true
  if (input === false) return false
  if (!input) {
    return null
  }

  if (input === 'true') return true
  if (input === 'false') return false

  return null
}
